import supportTypes from 'Enums/supportTypes'

/**
 * @param {SupportUser} user
 * @param {SupportCompany} company
 * @param {string} plan
 * @returns {ApiSupportTicket}
 */
export const formatPlanTicket = (user, company, plan) => ({
  userName: user.name,
  userEmail: user.email,
  supportType: supportTypes.supplier.changePlan,
  userId: user.id,
  companyId: company.id,
  message: `Olá, me chamo ${user.name}, sou da empresa ${company.name}. Eu gostaria de migrar do meu plano atual para o ${plan}`,
})

/**
 * @param {SupportUser} user
 * @param {SupportCompany} company
 * @param {number} type
 * @param {string} message
 * @returns {ApiSupportTicket}
 */
export const formatFormTicket = (user, company, type, message, cancellationReason) => ({
  userName: user.name,
  userEmail: user.email,
  supportType: type,
  userId: user.id,
  companyId: company.id,
  message: message.trim(),
  cancellationReason: cancellationReason
})

export default {
  formatPlanTicket,
  formatFormTicket,
}